export default {"src":"/_next/static/media/close.fcf35723.svg","height":25,"width":24};